import { render, staticRenderFns } from "./detailedLeaseStatement.vue?vue&type=template&id=644128d6&scoped=true"
import script from "./detailedLeaseStatement.vue?vue&type=script&lang=js"
export * from "./detailedLeaseStatement.vue?vue&type=script&lang=js"
import style0 from "./detailedLeaseStatement.vue?vue&type=style&index=0&id=644128d6&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644128d6",
  null
  
)

export default component.exports